import { ScannerSettings } from '../../types/scanner';

/**
 * Settings saved before the duplex checkbox existed always carry `duplex: false` (the old,
 * never-user-facing default), even though every scan ran hardcoded to duplex-on. Loading one of
 * those blobs must still resolve to duplex-on, or every existing user would silently get
 * simplex scanning the first time they load the page after the checkbox ships. `duplexConfigured`
 * marks a settings blob as having been saved through a UI that actually exposed the choice.
 */
export const resolveStoredScannerSettings = (storedJson: string | null): ScannerSettings => {
  const defaults: ScannerSettings = {
    colorscale: '0',
    dpi: '150',
    duplex: true,
    source: 'none',
    creation: new Date(0),
  };
  if (!storedJson) return defaults;

  const parsed = JSON.parse(storedJson) as ScannerSettings;
  const settings = parsed.duplexConfigured ? parsed : { ...parsed, duplex: true };
  settings.creation = new Date(settings.creation);
  return settings;
};
